import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:px-6 px-4" }
const _hoisted_2 = { key: 3 }
const _hoisted_3 = {
  key: 0,
  class: "grid grid-cols-5 lg:grid-cols-10 mb-20 sm:mb-0"
}
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = { class: "mt-2 pr-2 lg:max-w-screen-md lg:pr-6 2xl:max-w-screen-2xl" }
const _hoisted_6 = { class: "col-span-5 lg:col-span-4" }
const _hoisted_7 = { class: "sm:pl-2 pt-6 lg:pl-10" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import NoDataYet from "@/components/layout/NoDataYet.vue";
import PageHeader from "@/components/layout/PageHeader.vue";
import { useStreams } from "@/composables/stream";
import CameraNavbar from "@/views/camera/components/CameraNavbar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraItemLayout',
  props: {
  onlyLeft: {
    type: Boolean,
    required: false,
  },
  noData: {
    type: Boolean,
  },
  cameraId: {
    type: String,
  },
},
  setup(__props) {

const props = __props;

const { streams } = useStreams();
const route = useRoute();
const { t } = useI18n();

const currentStream = computed(() =>
  streams.value.find(
    (stream) =>
      stream.camera_id === route.params.camera_id &&
      props.cameraId !== t("app_features.site_activity"),
  ),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (currentStream.value && !__props.onlyLeft)
      ? (_openBlock(), _createBlock(PageHeader, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(currentStream.value.name), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (currentStream.value && !__props.onlyLeft)
      ? (_openBlock(), _createBlock(CameraNavbar, {
          key: 1,
          stream: currentStream.value
        }, null, 8, ["stream"]))
      : _createCommentVNode("", true),
    (__props.noData)
      ? (_openBlock(), _createBlock(NoDataYet, {
          key: 2,
          noData: __props.noData,
          style: { maxHeight: 'calc(100vh - 150px)' }
        }, null, 8, ["noData"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!__props.onlyLeft && !__props.noData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _renderSlot(_ctx.$slots, "contentLeft")
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "contentRight")
                  ])
                ])
              ]))
            : _renderSlot(_ctx.$slots, "contentLeft", { key: 1 })
        ]))
  ]))
}
}

})